import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { fallbackContent } from './data/content';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const WebsiteContentContext = createContext(fallbackContent);

export const WebsiteContentProvider = ({ children }) => {
  const [content, setContent] = useState(fallbackContent);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await axios.get(`${API}/website-content`, { timeout: 8000 });
        if (alive && res.data) {
          // Merge with fallback so any missing keys keep their defaults
          setContent({ ...fallbackContent, ...res.data });
        }
      } catch (e) {
        // keep fallback content silently
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  return <WebsiteContentContext.Provider value={content}>{children}</WebsiteContentContext.Provider>;
};

export const useWebsiteContent = () => useContext(WebsiteContentContext);
